import {
  // ChevronUp,
  Edit,
  Trash2,
  // PlusCircle,
  // RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { useLocation, useNavigate } from "react-router-dom";

// import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import { useCheckUserPermission } from "../../common/userPermission";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";

const faqMasterDelete = "FaqMasterDelete";

const FaqMasterList = () => {
  // const location = useLocation();
  // const parts = location.pathname;
  // let pathname = parts?.trim()?.split("/");
  // const dispatch = useDispatch();
  const user_data = useSelector((state) => state.user_data);
  // const data = useSelector((state) => state.toggle_header);
  // const ID = localStorage.getItem("ID");
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  
  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // showLoadingA?lert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };
  
  // const showLoadingAlert = () => {
  //   MySwal.fire({
  //     title: "Deleting...",
  //     text: "Please wait while we process your request.",
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       MySwal.showLoading(); // Show loading spinner
  //     },
  //   });
  // };
  
  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "FaqMaster",
    };
  
    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });
  
      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your faq has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
        prodcutDataListApi()
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
      size : 120
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Question",
      accessorKey: "question",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Answer",
      accessorKey: "answer",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size : 380,
      Cell: ({ cell }) => (
        <div
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "100%"
          }}
          title={cell.getValue()} // Show full text on hover
        >
          {cell.getValue()}
        </div>
      )
    },
    {
      header: "Active",
      accessorKey: "isActive",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ row }) => (
        <span className={row.original.isActive ? "btn btn-primary btn-sm me-2" : "btn btn-outline-primary btn-sm me-2"}>
          {row.original.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(route.FaqMaster) && (
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.FaqMaster}/${row.original.ID}`);
              console.log("Edit row:", row.original.ID);
            }}
          >
            <Edit className='custome-icon-size' />
          </button>
          )}
          {useCheckUserPermission(faqMasterDelete) && (
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.ID);
              // handleDelete(row.original.ID);
            }}
          >
            <Trash2 className='custome-icon-size' />
          </button>
          )}
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/FaqMaster?businessId=${user_data?.businessId || 0}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
      setLoading(false);
    } else {
      console.log(response, "data");
      setLoading(false);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  
  const exportData = productlist.map((item) => ({
    ID: item?.ID,
    BusinessName: item?.businessName,
    Question: item?.question,
    Answer: item?.answer,
  }));

  return (
    <>
    <LoadingSpinner isLoading={loading} />
    <div className="page-wrapper">
      <div className="content">
          <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.FaqMaster}
        />
        
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default FaqMasterList;
